import React, { Component } from "react";
import _ from "lodash";
import { Layout } from "antd";
import { connect } from "react-redux";
import Ajax from "Pub/js/ajax";
import platform from "Pub/js/platform";
import classNames from "classnames";
import { updateSelectedCards, setSiderCollapsed } from "Store/GridLayout/action";
import Notice from "Components/Notice";
import { widgetIconMap } from "Components/AppIconList";
import { getCardList, PUB_WIDGET_APPCODES, getQueryCloud } from "../utilService";
import HelpToolTip from "./HelpToolTip";
import SiderContent from "./SiderContent";
import "./index.less";
const { Sider } = Layout;
const { NCDiv, NCTabs } = platform.base;
const { NCTabPane } = NCTabs;
const { PubSub } = platform;
import { getCloudMenus, getMenus } from "Pub/js/allApps";
import { getCurrentLangText } from "Pub/js/getMulti";

class MySider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appGroupArr: null,
            widgetGroupArr: null,
            widgetDomainList: [],
            appCascaderSelect: [],
            widgetCascaderSelect: [],
            tabActiveKey: "app",
            toolTipVisible: true,
        };
    }
    componentDidMount() {
        this.initSiderData();
        
        // 工作台设计器（工作台管理节点设计进来的），默认打开
        const { relateidObj } = this.props;
        if (relateidObj.type === 'workbench') {
            this.setState({ collapsed: false });
            this.props.setSiderCollapsed(false);
        }
    }

    componentWillUnmount() {
        //组件销毁收起侧边栏
        this.props.setSiderCollapsed(true);
    }
    initSiderData = () => {
        const relateidObj = this.props.relateidObj;

        let ajaxData = {};
        if (relateidObj.type === "userID") {
            ajaxData = {};
        } else if (relateidObj.type === "is_group") {
            ajaxData = { is_group: relateidObj.data };
        } else if (relateidObj.type === "responsibility") {
            ajaxData = { pk_responsibility: relateidObj.data };
        }
        let queryUrl = this.props.location && this.props.location.search;
        if (queryUrl && queryUrl.indexOf("pk_responsibility") !== -1) {
            let querySubString = queryUrl.substring(queryUrl.indexOf("pk_responsibility"));
            let relateid = querySubString.substring(querySubString.indexOf("=") + 1);
            ajaxData.pk_responsibility = relateid; //存relateid
        } else if (queryUrl && queryUrl.indexOf("is_group=true") !== -1) {
            // 集团管理员应用管理跳转工作桌面设置 2019-08-16
            ajaxData = { is_group: true };
        }
        //部件页签
        if (this.getTab().isWidget) {
            ajaxData = { ...ajaxData, ...{ apptype: "2" } };
        }
        // bip菜单是否要请求
        ajaxData = { ...ajaxData, ...getQueryCloud(queryUrl), is_workbenchmanage: relateidObj.type === 'workbench' };

        const info = {
            name: this.props.json["DesktopSetting-000004"] /* 国际化处理： 工作桌面配置*/,
            action: this.props.json[
                "DesktopSetting-000027"
            ] /* 国际化处理： 查询一二级领域模块*/,
        }
        Promise.all([
            getMenus({
                info,
                data: ajaxData,
                loading: true
            }),
            getCloudMenus({
                info
            })
        ]).then(([menuData, cloudMenuData]) => {
            const data = [...menuData, ...cloudMenuData];
            if (data.length > 0) {
                //查应用
                if (this.getTab().isApp) {
                    const appCascaderSelect = [data[0].value, data[0].children[0].value];
                    this.onCascaderChange(appCascaderSelect);
                    this.setState({
                        appDomainList: data,
                        appCascaderSelect,
                    });
                } else if (this.getTab().isWidget) {
                    //查部件
                    const widgetCascaderSelect = [data[0].value];
                    const widgetDomainList = _.cloneDeep(data).map(item => {
                        delete item.children;
                        return item;
                    });
                    this.onCascaderChange(widgetCascaderSelect);
                    this.setState({
                        widgetDomainList,
                        widgetCascaderSelect,
                    });
                }
            } else {
                if (data.length === 0) {
                    Notice({
                        status: "warning",
                        msg: this.props.json[
                            "DesktopSetting-000028"
                        ] /* 国际化处理： 领域模块数据为空*/,
                    });
                } else {
                    Notice({ status: "error", msg: data });
                }
            }
        })
    };

    //应用名模糊搜索
    onInputSearch = searchVal => {
        const { tabActiveKey } = this.state;
        if (searchVal === "") {
            return;
        }
        const relateidObj = this.props.relateidObj;
        let ajaxData = {};
        const apptypeObj = this.getTab().isApp
            ? { apptype: "1" }
            : this.getTab().isWidget
                ? { apptype: "2" }
                : {};
        if (relateidObj.type === "userID") {
            ajaxData = { search_content: searchVal };
        } else if (relateidObj.type === "is_group") {
            ajaxData = {
                search_content: searchVal,
                is_group: relateidObj.data,
            };
        } else if (relateidObj.type === 'responsibility') {
            ajaxData = {
                search_content: searchVal,
                pk_responsibility: relateidObj.data,
            };
        } else {
            ajaxData = { search_content: searchVal };
        }
        ajaxData = { ...ajaxData, ...apptypeObj };

        Ajax({
            url: `/nccloud/platform/appregister/searchmenuitem.do`,
            info: {
                name: this.props.json["DesktopSetting-000004"] /* 国际化处理： 工作桌面配置*/,
                action: this.props.json[
                    "DesktopSetting-000029"
                ] /* 国际化处理： 模糊搜索应用和部件*/,
            },
            data: {
                ...ajaxData,
                is_workbenchmanage: relateidObj.type === 'workbench',
            },
            loading: true,
            success: res => {
                let { data, success } = res.data;
                if (success && data && data.children && data.children.length > 0) {
                    data.children = this.formatData(data.children);

                    this.setState({ [`${tabActiveKey}GroupArr`]: data.children.length ? [data] : [] });
                } else {
                    if (data && data.children && data.children.length === 0) {
                        this.setState({ [`${tabActiveKey}GroupArr`]: [] });
                    } else {
                        Notice({ status: "error", msg: data });
                    }
                }
            },
        });
    };
    //切换cascade
    onCascaderChange = (value, selectedOptions) => {
        if (value && value.length === 0) {return;}
        if (this.getTab().isApp) {
            this.onAppCascaderChange(value, selectedOptions);
        } else if (this.getTab().isWidget) {
            this.onWidgetCascaderChange(value);
        }
    };

    //领域模块搜索
    onAppCascaderChange = (value, selectedOptions) => {
        let cascaderValueArr = value;
        const relateidObj = this.props.relateidObj;
        const ownModuleID = cascaderValueArr[value.length - 1];
        let ajaxData = {};
        //应用页签
        if (relateidObj.type === "userID") {
            ajaxData = { own_module: ownModuleID };
        } else if (relateidObj.type === "is_group") {
            ajaxData = { own_module: ownModuleID, is_group: relateidObj.data };
        } else if (relateidObj.type === "responsibility") {
            ajaxData = {
                own_module: ownModuleID,
                pk_responsibility: relateidObj.data,
            };
        } else {
            ajaxData = { own_module: ownModuleID };
        }
        let queryUrl = this.props.location && this.props.location.search;
        if (queryUrl && queryUrl.indexOf("pk_responsibility") !== -1) {
            let querySubString = queryUrl.substring(queryUrl.indexOf("pk_responsibility"));
            let relateid = querySubString.substring(querySubString.indexOf("=") + 1);
            ajaxData.pk_responsibility = relateid; //存relateid
        } else if (queryUrl && queryUrl.indexOf("is_group=true") !== -1) {
            // 集团管理员应用管理跳转工作桌面设置 2019-08-16
            ajaxData.is_group = true;
        }
        ajaxData = { ...ajaxData, ...{ apptype: '1' } };
        //云应用传is_cloud_app
        if (selectedOptions && selectedOptions.length) {
            const selectedModule = selectedOptions[value.length - 1];
            ajaxData = {
                ...ajaxData,
                is_cloud_app: selectedModule.is_cloud_app,
            };
        }
        // bip菜单是否要请求
        ajaxData = { ...ajaxData, ...getQueryCloud(queryUrl), is_workbenchmanage: relateidObj.type === 'workbench' };
        getMenus({
            info: {
                name: this.props.json["DesktopSetting-000004"] /* 国际化处理： 工作桌面配置*/,
                action: this.props.json[
                    "DesktopSetting-000030"
                ] /* 国际化处理： 查询模块下应用和部件*/,
            },
            data: ajaxData,
        }).then(data => {
            if (data && data.length > 0) {
                _.forEach(data, d => {
                    d.children = this.formatData(d.children);
                });
                this.setState({ appGroupArr: data });
            } else {
                if (data && data.length === 0) {
                    this.setState({ appGroupArr: [] });
                } else {
                    Notice({ status: "error", msg: data });
                }
            }
        })
    };
    //切换领域搜索部件
    onWidgetCascaderChange = value => {
        const relateidObj = this.props.relateidObj;
        const fieldCode = value[0];
        let ajaxData = {};
        if (relateidObj.type === "userID") {
            ajaxData = { fieldCode };
        } else if (relateidObj.type === "is_group") {
            ajaxData = { fieldCode, is_group: relateidObj.data };
        } else if (relateidObj.type === "responsibility") {
            ajaxData = {
                fieldCode,
                pk_responsibility: relateidObj.data,
            };
        } else {
            ajaxData = { fieldCode };
        }
        let queryUrl = this.props.location && this.props.location.search;
        if (queryUrl && queryUrl.indexOf("pk_responsibility") !== -1) {
            let querySubString = queryUrl.substring(queryUrl.indexOf("pk_responsibility"));
            let relateid = querySubString.substring(querySubString.indexOf("=") + 1);
            ajaxData.pk_responsibility = relateid; //存relateid
        } else if (queryUrl && queryUrl.indexOf("is_group=true") !== -1) {
            // 集团管理员应用管理跳转工作桌面设置 2019-08-16
            ajaxData.is_group = true;
        }
        Ajax({
            url: "/nccloud/platform/appregister/queryparttree.do",
            info: {
                name: this.props.json["DesktopSetting-000004"] /* 国际化处理： 工作桌面配置*/,
                action: this.props.json[
                    "DesktopSetting-000030"
                ] /* 国际化处理： 查询模块下应用和部件*/,
            },
            data: {
                ...ajaxData,
                is_workbenchmanage: relateidObj.type === 'workbench',
            },
            loading: true,
            success: res => {
                let { data, success } = res.data;
                if (success && data && data.length > 0) {
                    _.forEach(data, d => {
                        d.children = this.formatData(d.children);
                    });
                    _.remove(data, d => !d.children || !d.children.length); // 去掉children为空的
                    this.setState({ widgetGroupArr: data });
                } else {
                    if (data && data.length === 0) {
                        this.setState({ widgetGroupArr: [] });
                    } else {
                        Notice({ status: "error", msg: data });
                    }
                }
            },
        });
    };

    //每组的全选与否
    onCheckAllChange = groupData => {
        //将已选卡片放进store
        this.props.updateSelectedCards(getCardList(groupData));
    };

    //单个卡片的选择
    onChangeChecked = (groupData, id) => {
        //将已选卡片放进store
        this.props.updateSelectedCards(getCardList(groupData, id));
    };

    //重置已选的卡片
    resetSelectedCards = () => {
        const key = `${this.state.tabActiveKey}GroupArr`;
        let groupArr = _.cloneDeep(this.state[key]);
        _.forEach(groupArr, a => {
            _.forEach(a.children, c => {
                if (c.checked) {
                    c.checked = false;
                }
            });
            a.checkedAll = false;
            a.indeterminate = false;
        });
        this.setState({ [key]: groupArr });
    };

    //切换tab
    handleTabChange = key => {
        this.setState({ tabActiveKey: key }, () => {
            if (!this.state.widgetGroupArr) {
                this.initSiderData();
            }
        });
    };
    formatData = data => {
        let result = _.cloneDeep(data);
        const notRepeatList = [
            PUB_WIDGET_APPCODES.commonUsedApp,
            PUB_WIDGET_APPCODES.externalLinks,
            PUB_WIDGET_APPCODES.quickLaunch,
            '10182007', // 公共查询
            '10182006', // 指标卡（之后这些用appcode来判断的应该换成部件类型）
            '10182008', // 单据统计
        ]; //拖拽不校验重复的item
        result.forEach(item => {
            item.checked = false;
            item.height = Number(item.height);
            item.width = Number(item.width);
            item.isNotRepeat = notRepeatList.includes(item.appcode);
            item.name = getCurrentLangText('label', item); // 当前语言下要展示label
        });
        return result;
    };

    getTab = () => ({
        isApp: this.state.tabActiveKey === "app", //应用页签
        isWidget: this.state.tabActiveKey === "widget", //部件页签
    });
    //渲染sider内容
    renderSiderContent = key => {
        const isWidget = key === "widget";
        const iconList = _.flatten(Object.values(widgetIconMap));
        return (
            <SiderContent
                json={this.props.json}
                contentData={this.state[`${key}GroupArr`]}
                defaultCascaderValue={this.state[`${key}CascaderSelect`]}
                cascaderOptions={this.state[`${key}DomainList`]}
                showIcon={isWidget}
                iconList={isWidget && iconList}
                onSearch={this.onInputSearch}
                onCascaderChange={this.onCascaderChange}
                onCheckAllChange={this.onCheckAllChange}
                onChangeChecked={this.onChangeChecked}
                resetSelectedCards={this.resetSelectedCards}
            />
        );
    };
    render() {
        const { siderCollapsed } = this.props;
        const tabList = [
            { key: "app", tab: this.props.json["DesktopSetting-000051"] }, //应用
            { key: "widget", tab: this.props.json["DesktopSetting-000052"] }, //部件
        ];
        return (
            <HelpToolTip json={this.props.json} isMount={!siderCollapsed}>
                <div
                    className={classNames("nc-workbench-home-sider-container", { collapsed: siderCollapsed })}
                >
                    <Sider className="nc-workbench-home-sider" width={328} theme="light">
                        <NCDiv
                            className="sider-content"
                            areaCode={NCDiv.config.Area}
                            fieldid="left"
                        >
                            <NCTabs
                                defaultActiveKey={tabList[0].key}
                                activeKey={this.state.tabActiveKey}
                                onChange={this.handleTabChange}
                                className="sider-tabs"
                                tabContentClassName='workbench-tab-content'
                                tabBarClassName='workbench-tab-bar'
                            >
                                {tabList.map(item => (
                                    <NCTabPane className="workbench-tab-content-pane" tab={item.tab} key={item.key} >
                                        {this.renderSiderContent(item.key)}
                                    </NCTabPane>
                                ))}
                            </NCTabs>
                        </NCDiv>
                    </Sider>
                    <div
                        className="collapse-btn expand"
                        onClick={() => {
                            this.props.setSiderCollapsed(true);
                        }}
                    >
                        <i className="iconfont icon-shouqi4" fieldid="collapse" />
                    </div>
                </div>
            </HelpToolTip>
        );
    }
}
export default connect(
    state => ({
        json: state.gridLayoutData.json,
        selectedCards: state.gridLayoutData.selectedCards,
        groups: state.gridLayoutData.groups,
        siderCollapsed: state.gridLayoutData.siderCollapsed,
        editable: state.gridLayoutData.editable,
    }),
    {
        updateSelectedCards,
        setSiderCollapsed,
    },
    null,
    { forwardRef: true },
)(MySider);
